export default "__VITE_ASSET__BdO2P0$o__"